import { CreateProject, Org, SelectOrg } from "@views/index"
import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import ProjectLayout from "@/layouts/ProjectLayout.vue"
import { getOrg } from "@/services/clerk"
import { useProjectStore } from "@stores/projectStore"
import {
   orgGuard,
   subscriptionGuard,
   selectOrgGuard,
   createProjectGuard,
} from "../guards/composable"

export default [
   {
      path: "/orgs/select",
      name: "SelectOrg",
      component: SelectOrg,
      beforeEnter: selectOrgGuard,
   },
   {
      name: "CreateProject",
      path: "/orgs/:orgSlug/projects/create",
      component: CreateProject,
      meta: {
         layout: "OrgsLayout",
      },
      beforeEnter: createProjectGuard, // Redirect to existing project if one exists
   },
   {
      path: "/orgs/:orgSlug/projects",
      name: "OrgProjects",
      component: ProjectLayout,
      meta: {
         layout: "OrgsLayout",
      },
      beforeEnter: subscriptionGuard, // Allow viewing projects during trials/onboarding
   },
   {
      path: "/orgs/setup",
      name: "OrgsSetup",
      component: () => import("@views/onboarding/SubscriptionActivating.vue"),
      meta: {
         layout: "AppLayoutDefault",
      },
      beforeEnter: async (
         to: RouteLocationNormalized,
         from: RouteLocationNormalized,
         next: NavigationGuardNext,
      ) => {
         // Ensure user has an active org
         const org = await getOrg()
         if (!org) {
            return next({ name: "SelectOrg" })
         }
         // Continue to activation page which will poll for subscription status
         return next()
      },
   },
   {
      path: "/orgs/:orgSlug",
      name: "OrgHome",
      component: Org,
      meta: {
         layout: "OrgsLayout",
      },
      beforeEnter: async (
         to: RouteLocationNormalized,
         from: RouteLocationNormalized,
         next: NavigationGuardNext,
      ) => {
         const projectStore = useProjectStore()
         await projectStore.getActiveOrgProjects()
         return orgGuard(to, from, next) // Use standard org guard for consistency
      },
   },
]
